import { compose, lifecycle, withHandlers, withState } from "recompose";
import { connect } from "react-redux";
import { fetchInvoice, fetchInvoicePrint, fetchPaymentTransaction } from "shadow-client/endpoints/accountingApi";
import { saveAs } from "file-saver";
import { withRouter } from "react-router-dom";
import { withTranslator } from "app/decorators";
import CheckoutResponse from "./CheckoutResponse";

function getTransactionId() {
  return window.location.href.split("?payment_transaction_id=")[1];
}

function componentWillMount() {
  const { fetchInvoice, setInvoiceData, setMessageState, setIsLoading, fetchPaymentTransaction } = this.props;
  const transactionId = getTransactionId();
  fetchPaymentTransaction(transactionId).then(paymentTransaction => {
    const state = paymentTransaction.get("state");
    let messageState;
    switch (state) {
      case "accepted":
        messageState = "La transaction a été réalisée avec succès";
        fetchInvoice(paymentTransaction.get("invoice")).then(invoice => {
          setInvoiceData(invoice.toJS());
          setMessageState(messageState);
          setIsLoading(false);
        });
        break;
      case "canceled":
        messageState = "La transaction a été annulée";
        break;
      case "refused":
        messageState = "La transaction a été refusée";
        break;
      default:
        messageState = "Une erreur est survenue lors de la transaction";
        break;
    }

    if (state !== "accepted") {
      setMessageState(messageState);
      setIsLoading(false);
    }
  });
}

const onInvoicePrint = ({ fetchInvoicePrint, invoiceData }) => event => {
  const invoiceId = invoiceData["@id"];
  return fetchInvoicePrint(invoiceId, "print").then(({ type, content }) => {
    saveAs(new Blob([content], { type }), "facture");
  });
};

export default compose(
  withRouter,
  connect(null, { fetchInvoice, fetchInvoicePrint, fetchPaymentTransaction }),
  withState("invoiceData", "setInvoiceData", {}),
  withState("isLoading", "setIsLoading", true),
  withState("messageState", "setMessageState", "Retour après transaction"),
  withHandlers({ onInvoicePrint }),
  lifecycle({ componentWillMount }),
  withTranslator
)(CheckoutResponse);



// WEBPACK FOOTER //
// ./src/app/components/CheckoutResponse/CheckoutResponseContainer.js